import { TopicCard } from "@calcom/features/topics/components/TopicCard";
import { Hero } from "@components/ui/Hero";
import { Button } from "@calcom/ui";
import React from "react";
import type { InferGetStaticPropsType } from "next";
import { getNextAvailableSlotForTopics } from "helpers/getNextAvailableSlotForTopics";
import { fetchExpertAndBookingData, fetchScheduleData, fetchTopicsData } from "@lib/experts/api";
export type TopicsPageProps = InferGetStaticPropsType<typeof getStaticProps>;

function TopicsPage({ topics, booking, slots }: TopicsPageProps) {
  const nextAvailableSlotForTopics = getNextAvailableSlotForTopics(topics, slots);
  const topicsWithAvailableSlot = topics.filter((topic) => {
    const nextAvailableSlot = nextAvailableSlotForTopics[topic.name];
    return nextAvailableSlot != null;
  });

  return (
    <>
      <Hero>
        <div className="container relative py-12 md:py-32">
          <h1 className="text-5xl md:text-6xl">Expertise areas</h1>
          <p className="mt-4 max-w-3xl text-2xl leading-normal">
            Our technological and business consulting service offers expert guidance and support to help
            businesses overcome challenges, capitalise on opportunities and achieve their goals. Choose a
            topic that interests you, and let us help you achieve your business objectives.
          </p>
          <Button href="#topics" size="2xl" color="secondary" className="mt-4">
            View topics
          </Button>
        </div>
      </Hero>
      <div className="container">
        <hr className="border-brand-500" />
      </div>
      <main>
        <div className="container py-12 md:py-32" id="topics">
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-10 xl:grid-cols-3">
            {topicsWithAvailableSlot.map((topic) => (
              <TopicCard
                key={topic.id}
                topic={topic}
                booking={booking}
                userList={topic.userList}
                topicNextAvailableSlot={topic.name ? nextAvailableSlotForTopics[topic.name] : null}
              />
            ))}
          </div>
        </div>
      </main>
    </>
  );
}

export const getStaticProps = async () => {
  try {
    const topics = await fetchTopicsData();
    const { booking, experts } = await fetchExpertAndBookingData();
    const expertsList = experts.map((e) => e.username);
    const slots = await fetchScheduleData(expertsList, booking);

    return {
      props: {
        topics,
        slots,
        booking,
      },
      revalidate: 60,
    };
  } catch (error) {
    console.error("Error fetching data in getStaticProps:", error);
    return { notFound: true };
  }
};

export default TopicsPage;
